import CenterForm from "../components/center-form";
import TextInput from "../components/text-input";
import styled from "styled-components";
import {ChangeEvent, createRef, FormEvent, useContext, useState} from "react";
import PrimaryButton from "../components/primary-button";
import CreateAccountModal, {CreateAccountModalState} from "../views/create-account-modal";
import {useRecoilState} from "recoil";
import FirebaseContext from "../utils/firebase-context";

const CreateAccountLink = styled.div`
  position: fixed;
  bottom: .5rem;
  left: .5rem;
`;

const Error = styled.div`
  color: red;
  font-weight: bold;
`;

const emptyLoginState = {
    email: "",
    password: ""
};

export default function AuthScreen() {
    const [error, setError] = useState("");
    const [loginState, setLoginState] = useState(emptyLoginState);
    const firebase = useContext(FirebaseContext);
    const onChange = (e: ChangeEvent<HTMLInputElement>) => {
        setLoginState(ls => ({...ls, [e.target.name]: e.target.value}));
    };

    const ref = createRef<HTMLFormElement>();

    const [createModalState, setCreateModalState] = useRecoilState(CreateAccountModalState);

    const onSubmit = async (e: FormEvent) => {
      e.preventDefault();

      await login();
    };

    const submit = async () => {
        if (!ref.current) {
            await login();
            return;
        }

        ;
    };

    const login = async () => {
        await firebase.signIn(loginState.email, loginState.password)
            .catch(() => setError("Fehler beim Login, checke deine Eingaben"));
    };

    return <>
        <CenterForm onSubmit={onSubmit} ref={ref}>
            {error !== "" && <Error>{error}</Error>}
            <TextInput
                value={loginState.email}
                onChange={onChange}
                placeholder={"Email Adresse"}
                type={"email"}
                name={"email"}
            />
            <TextInput
                value={loginState.password}
                onChange={onChange}
                placeholder={"Passwort"}
                type={"password"}
                name={"password"}
            />
            <PrimaryButton onClick={submit}>
                Einloggen
            </PrimaryButton>
        </CenterForm>
        <CreateAccountLink>
            <PrimaryButton onClick={() => setCreateModalState(true)}>
                Neuen Account erstellen
            </PrimaryButton>
        </CreateAccountLink>
        {createModalState && <CreateAccountModal />}
    </>
}